import pluralize from 'pluralize'

export default days => {
  if (days / 7 < 1) {
    return pluralize('day', days, true)
  }
  // Note the plus sign that drops any "extra" zeroes at the end.
  const weeks = +(days / 7).toFixed(0)
  return pluralize('week', weeks, true)
}
